import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import qr from "../../Assets/Projects/qr.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import netflix from "../../Assets/Projects/netflix.png";
import cert from "../../Assets/Projects/cert.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Portfolio"
              description="A React Portfolio Web App is a personal showcase built with React, highlighting your skills, projects, and achievements. It offers an interactive and visually appealing way to present your work, complete with responsive design and smooth navigation, making it easy for potential clients or employers to explore your capabilities."
              ghLink="https://github.com/saroopskesav/portfolio"
              demoLink="https://portfolio-saroop-s-kesavs-projects.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={qr}
              isBlog={false}
              title="QR Code Generator"
              description="This QR Code Generator allows users to quickly convert any text into a scannable QR code. Simply input the desired text, and the tool generates a unique QR code that can be scanned using a mobile device to instantly display the text. Ideal for sharing links, contact information, or messages in a compact and accessible format."
              ghLink="https://github.com/saroopskesav/qr-code-generator"
              demoLink="https://qr-code-generator-rouge-eight.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={netflix}
              isBlog={false}
              title="Netflix Clone"
              description="A fully functional Netflix clone built with React, Firebase, and The Movie Database (TMDb) API. The app features user authentication with Firebase, a dynamic homepage showcasing trending movies and TV shows, a responsive UI, and the ability to add movies to a personalized watchlist. API integrations fetch real-time movie details, and Firebase handles user data storage efficiently."
              ghLink="https://github.com/saroopskesav/netflix-clone"
              demoLink="https://netflix-clone-one-green.vercel.app/"             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cert}
              isBlog={false}
              title="SSL Certificate Monitor"
              description="SSL Certificate Monitor is a web application that tracks the status and expiry of SSL certificates for domains. It features a React dashboard with tables and graphs, a FastAPI backend with a REST API for CRUD operations and scheduled certificate checks, and real-time notifications for invalid inputs. The app is fully Dockerized for easy deployment."
              ghLink="https://github.com/saroopskesav/ssl-cert-monitor"
              demoLink="https://ssl-cert-monitor-dashboard.vercel.app/"             
            />
          </Col>

          {/*<Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Title4"
              description="Desc"
              ghLink="https://github.com/saroopskesav"
              demoLink="https://github.com/saroopskesav"  
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Title5"
              description="Desc"
              ghLink="https://github.com/saroopskesav"
              demoLink="https://github.com/saroopskesav"  
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Title6"
              description="Desc"
              ghLink="https://github.com/saroopskesav"
              demoLink="https://github.com/saroopskesav"  
            />
          </Col>*/}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
